import React from 'react'
import Typography from '@mui/material/Typography'

// for external links
import Link from '@mui/material/Link'

// for internal links
import { Link as RouterLink } from 'react-router-dom'

const Breadcrumb = props => {
  const { text, href, link } = props

  // external links (e.g. to legacy Ops)
  if (href) {
    return (
      <Link href={href}>
        <Typography color='textPrimary'>{text}</Typography>
      </Link>
    )
  }

  // use a RouterLink if there's an internal link
  // use a span if there's no link
  const LinkComponent = link ? RouterLink : 'span'
  const linkProps = link ? { to: link } : {}

  return (
    <LinkComponent {...linkProps}>
      <Typography color='textPrimary'>{text}</Typography>
    </LinkComponent>
  )
}

export default Breadcrumb
